import { backOff } from "exponential-backoff";
import { delay } from "./delay";

export const MAX_RETRY = 3;
export const MAX_DELAY = 10_000;

/**
 * Retry after 10 seconds of no response
 */
export function retry<T>(request: () => Promise<T>): Promise<T> {
  return backOff(
    () =>
      Promise.race([
        request(),
        delay(MAX_DELAY).then(() =>
          Promise.reject(`Request timed out after ${MAX_DELAY}ms`)
        ),
      ]),
    {
      numOfAttempts: MAX_RETRY,
    }
  );
}
